import React, { useEffect, useState } from 'react'
import CMS from '../../components/cms/CMS'
import PageBanner from '../../components/general/PageBanner'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import CMSTable from '../../components/general/CMSTable'
import { useNavigate } from 'react-router-dom'
import CrudPage from './CrudPage'
import { fetchPageGetAll } from '../../redux/slices/pageGetAllSlice'
import { fetchPageDelete } from '../../redux/slices/pageDeleteSlice'
import { columns } from '../../utilities/columns/pageColumns'

const Page = () => {
    const [modal, setModal] = useState(false)
    const [changed, setChanged] = useState(false)
    const [selectedItem, setSelectedItem] = useState(0)
    const [loading, setLoading] = useState(false);
    const pages = useSelector((state) => state.pageGetAll.data)
    const lang = useSelector((state) => state.lang.lang)
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const navigation = useNavigate()

    const getData = async () => {
        setLoading(true);
        await dispatch(fetchPageGetAll())
        setChanged(false)
        setLoading(false);
    }

    const deleteData = async (id) => {
        await dispatch(fetchPageDelete({ id: id }))
        getData()
    }

    useEffect(() => { getData() }, [dispatch, changed])

    return (
        <CMS>
            <PageBanner
                modal={modal}
                setModal={setModal}
                title={t("page_management")}
                description={t("page_management_desc")}
                buttonText={t("page_add")}
                button={() => navigation(`/page-save`)}
            />

            <CMSTable
                columns={columns({
                    t: t,
                    modal: modal,
                    setModal: setModal,
                    lang: lang,
                    deleteData: deleteData,
                    navigation: navigation,
                    setSelectedItem: setSelectedItem
                })}
                data={pages}
                loading={loading}
            />

            <CrudPage
                showMenu={modal}
                setShowMenu={setModal}
                setChanged={setChanged}
                getAllData={getData}
                setSelectedItem={setSelectedItem}
                selectedItem={selectedItem}
                t={t}
            />
        </CMS>
    )
}

export default Page
